import Step from "./Step";

class Step5 extends Step {
    constructor(registrationAllowed = true) {
        super(6, 'congrats', $(`[data-register-step="congrats"]`));

        // UI Elements for congratulations interface
        this.showDemoSchedulerBtn = $('#show_demo_scheduler');
        this.skipDemoBtn = $('#skip_demo_btn');
        this.directStartCard = $('.col-lg-6:has(#skip_demo_btn)');

        // UI Elements for demo views
        this.demoPlanningView = $('#demo_planning_view');
        this.demoScheduledView = $('#demo_scheduled_view');
        this.editDemoBtn = $('#edit_demo_btn');
        this.demoDateTimeSpan = $('#demo_date_time');

        // Store current demo data
        this.currentDemo = null;
        
        // Store registration allowed status
        this.registrationAllowed = registrationAllowed;
    }

    init() {
        console.log('Step5 init: Congratz');
        this.initializeViews();
        this.checkRegistrationStatus();
        this.attachEventHandlers();
        this.checkExistingDemo();
    }

    initializeViews() {
        // Re-query elements to ensure they exist
        this.demoPlanningView = $('#demo_planning_view');
        this.demoScheduledView = $('#demo_scheduled_view');
        this.demoDateTimeSpan = $('#demo_date_time');

        console.log('Step5: Initializing views', {
            planning: this.demoPlanningView.length,
            scheduled: this.demoScheduledView.length
        });

        this.demoScheduledView.hide();
        this.demoPlanningView.show();
    }

    checkRegistrationStatus() {
        console.log('Step5: Checking registration status', this.registrationAllowed);
        
        // If registration is not allowed, disable the direct start option with an alert
        if (!this.registrationAllowed) {
            console.log('Step5: Registration not allowed, disabling direct start option');
            
            // Disable the skip demo button
            const skipDemoBtn = $('#skip_demo_btn');
            if (skipDemoBtn.length) {
                skipDemoBtn.prop('disabled', true);
                skipDemoBtn.addClass('opacity-50');
            }
            
            // Add an alert message to the Direct Start card
            const directStartCard = $('#direct_start_option .card-body');
            if (directStartCard.length) {
                // Check if alert doesn't already exist
                if (!directStartCard.find('.registration-disabled-alert').length) {
                    const alertHTML = `
                        <div class="alert alert-warning d-flex align-items-center mb-0 mt-4 registration-disabled-alert" role="alert">
                            <div>
                                <strong>Niet beschikbaar</strong><br>
                                <small>Op dit moment is direct starten niet mogelijk. Plan een demo in voor persoonlijke begeleiding.</small>
                            </div>
                        </div>
                    `;
                    directStartCard.append(alertHTML);
                    console.log('Step5: Alert added to direct start card');
                }
            } else {
                console.warn('Step5: Could not find #direct_start_option card body');
            }
        } else {
            console.log('Step5: Registration is allowed, direct start option should be available');
        }
    }

    attachEventHandlers() {
        // ... (handlers need to be re-attached if elements are re-queried, but buttons are separate)
        // Actually, let's keep buttons in constructor or re-query them too.
        // For safety, let's query buttons here too if they differ.
        if (this.showDemoSchedulerBtn) this.showDemoSchedulerBtn.off('click');
        if (this.skipDemoBtn) this.skipDemoBtn.off('click');
        if (this.editDemoBtn) this.editDemoBtn.off('click');

        this.showDemoSchedulerBtn = $('#show_demo_scheduler');
        this.skipDemoBtn = $('#skip_demo_btn');
        this.editDemoBtn = $('#edit_demo_btn');

        this.showDemoSchedulerBtn.on('click', (e) => {
            e.preventDefault();
            this.planDemo();
        });

        this.skipDemoBtn.on('click', (e) => {
            e.preventDefault();
            this.startTrial();
        });

        this.editDemoBtn.on('click', (e) => {
            e.preventDefault();
            this.editDemo();
        });
    }

    planDemo() {
        this.goToStep('scheduler');
    }

    goToStep(stepNumber) {
        if (window.register) {
            window.register.goNext(stepNumber);
        }
    }

    async startTrial() {
        console.log('Step5: Navigating to location details step...');
        try {
            await API.post("/register/saveStep", {
                step: 6,
                data: { flow: 'skip' },
            });
        } catch (error) {
            console.error('Step5: Failed to save skip choice', error);
        }
        this.goToStep('location');
    }

    async checkExistingDemo() {
        try {
            const response = await API.get('/demo/existing');

            if (response.status === 'success' && response.demo) {
                console.log('Step5: Existing demo found', response.demo);
                this.currentDemo = response.demo;
                this.showScheduledDemoView();
            } else {
                console.log('Step5: No existing demo found');
            }
        } catch (error) {
            console.error('Step5: Error checking demo', error);
            // Planning view is already shown by default
        }
    }

    showPlanningView() {
        console.log('Step5: Showing Planning View');
        this.demoScheduledView.hide();
        this.demoPlanningView.show();
    }

    showScheduledDemoView() {
        console.log('Step5: Showing Scheduled View');
        if (this.currentDemo) {
            const demoDate = new Date(this.currentDemo.scheduled_at);
            const formattedDate = demoDate.toLocaleDateString('nl-NL', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            const formattedTime = demoDate.toLocaleTimeString('nl-NL', {
                hour: '2-digit',
                minute: '2-digit'
            });

            this.demoDateTimeSpan.text(`${formattedDate} om ${formattedTime}`);
        }

        this.demoPlanningView.hide();
        this.demoScheduledView.show();
    }

    editDemo() {
        if (this.currentDemo) {
            window.editingDemo = {
                id: this.currentDemo.id,
                scheduled_at: this.currentDemo.scheduled_at,
                notes: this.currentDemo.notes || ''
            };
        }

        this.goToStep(8); // Scheduler is step 8
    }
}

export default Step5;
